import ShowBracketApp from "./ShowBracketApp.vue";
import { vueApp } from "../Common/vueApp";

export default vueApp(ShowBracketApp);
